const htmlEl = document.documentElement;
const dirChangeCallbacks = new Set();
const dirChangeObserver = new MutationObserver(notifyDirChangeListeners);
let observing = false;
export function onHtmlDirChange(cb) {
  startObserver();
  dirChangeCallbacks.add(cb);
}
export function offHtmlDirChange(cb) {
  dirChangeCallbacks.delete(cb);
}
export function getHtmlDir() {
  if (isPageDirectionForced()) {
    return '';
  }
  return htmlEl.dir;
}
export function isPageDirectionRightToLeft() {
  const dir = getHtmlDir();
  return dir.toLowerCase() === 'rtl';
}
function startObserver() {
  if (!observing) {
    observing = true;
    dirChangeObserver.observe(htmlEl, {
      attributes: true,
      attributeFilter: ['dir']
    });
  }
}
function notifyDirChangeListeners() {
  const htmlDir = getHtmlDir();
  dirChangeCallbacks.forEach(cb => {
    cb(htmlDir);
  });
}
const MONS_PATHS_TO_FORCE_PAGE_DIRECTION = ['/abis/index.html', 'abis/listing', '/productclassify', '/productclassify-devo'];
function isPageDirectionForced() {
  if (window.Katal?.forceRespectRtl) {
    return false;
  }
  const url = window.location.href;
  return MONS_PATHS_TO_FORCE_PAGE_DIRECTION.some(path => url.indexOf(path) > -1);
}
//# sourceMappingURL=rtl-utils.js.map